import React, { useEffect } from "react";

/** Bouncing dots loader in the account primary colour; renders only the dots when text is empty. */
export const BouncingDots = ({ text = "Loading..." }) => (
    <div className="dc-loader" role="status" aria-live="polite">
        <div className="dc-loader-dots" aria-hidden="true">
            <span className="dc-loader-dot" />
            <span className="dc-loader-dot" />
            <span className="dc-loader-dot" />
            <span className="dc-loader-dot" />
        </div>
        {text ? <div className="dc-loader-text">{text}</div> : <span className="visually-hidden">Loading...</span>}
    </div>
);

/** Full-viewport overlay with the bouncing dots centred. */
export const LoaderOverlay = ({ text }) => {
    // The first overlay takes over from public/index.html's identical boot loader without a fade-in
    // (html.dc-booting); once it is dismissed, later overlays fade in as normal.
    useEffect(() => () => document.documentElement.classList.remove("dc-booting"), []);

    return (
        <div className="dc-loader-overlay">
            <BouncingDots text={text} />
        </div>
    );
};

/** In-place loader for a section, tab or lazy boundary (does not cover the page). */
export const InlineLoader = ({ text = "Loading...", className = "" }) => (
    <div className={`dc-loader-inline ${className}`}>
        <BouncingDots text={text} />
    </div>
);

export default BouncingDots;
